import { BillingModalEntityGridDatasource } from '@/modules/billing-module/shared/components/modal-entity/components/grid/config/billing-modal-entity-grid.datasource'
import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { billingAppliedBillableConceptService } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.service'
import { CommonFilterModel } from '@/api/resources/common/shared/models/common.models'
import { billingConfigInvoiceConceptsGridColumnDefs } from '@/modules/billing-module/shared/config/invoice-concepts-grid/billing-config-invoice-concepts-grid.column-defs'
import { AgColumnDefinition } from '@/shared/models/ag-grid.model'

export class BillingConfigInvoiceConceptsGridDatasource extends BillingModalEntityGridDatasource<AppliedBillableConceptResponse> {
    constructor(filterModel: CommonFilterModel) {
        super(billingAppliedBillableConceptService, filterModel)
    }

    getColumnDefs(): AgColumnDefinition[] {
        return billingConfigInvoiceConceptsGridColumnDefs()
    }
}
